import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';
import { STRUCTURE_TIPS } from '@/docs/tips/structure';

export const GroupTableHeaders = ({ t, onSort }: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:groups')}
        thClassName="min-w-[200px] max-sm:min-w-[170px]"
        sortable
        onSortClick={() => onSort?.('groupName')}
      />
      <TableHead
        text={t('common:companies')}
        thClassName="text-center min-w-0 w-0"
        infoTip={STRUCTURE_TIPS.companiesColumn}
      />
      <TableHead
        text={t('common:branches')}
        thClassName="text-center min-w-0 w-0"
        infoTip={STRUCTURE_TIPS.branchesColumn}
      />
      <TableHead
        text={t('common:usage')}
        thClassName="text-center min-w-0 w-[90px]"
        infoTip={STRUCTURE_TIPS.usageColumn}
      />
      <TableHead
        text={t('common:address')}
        thClassName="w-[220px] max-sm:min-w-[170px]"
      />
      <TableHead
        text={t('common:whiteLabel')}
        thClassName="min-w-0 w-0"
        infoTip={STRUCTURE_TIPS.whiteLabelColumn}
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
